export default "__VITE_ASSET__DbPvhwhB__"